import React from 'react';
import loadable from '@loadable/component';
import { homepageOnEnter } from 'features/Homepage/homepage.onenter.saga';

const Homepage = loadable(() => import('features/Homepage/HomepageContainer'));

export default (store, client) => ({
  path: '/',
  component: require('containers/App/App').App,
  indexRoute: {
    component: props => <Homepage {...props} />,
    onEnter: (nextState, replaceState, cb) =>
      store
        .runSagaOnce(homepageOnEnter, client, nextState, replaceState)
        .toPromise()
        .then(cb),
  },

  childRoutes: [
    // Include redirects first to support deep pathed redirects
    ...require('./Redirects').default,

    // Alphabetical order please!
    require('./About').default(store, client),
    require('./ContactRedirect').default(store, client),
    require('../features/ConfirmEmail/ConfirmEmail.route').ConfirmEmailRoute(store, client),
    require('../features/Corporate/Corporate.route').CorporateRoute(store, client),
    require('../features/Email/OptIn/OptIn.route').OptInRoute(store, client),
    require('./Explore').default(store, client),
    require('./Features').default(store, client),
    require('./Fitness').default(store, client),
    require('../features/Gifting/Gifting.route').GiftingRoute(store, client),
    require('./Go').default(store, client),
    require('../features/InviteAFriend/InviteAFriend.route').default(store, client),
    require('../features/InventoryDetail/ClassDetail.route').default(store, client),
    require('../features/InventoryDetail/InventoryDetail.route').default(store, client),
    require('../features/InventoryDetail/ScheduleShorthand.route').default(store, client),
    require('../features/InventoryDetail/InventoryDetailShorthand.route').default(store, client),
    require('./Live').default(store, client),
    require('../features/Login/Login.route').LoginRoute(store, client),
    require('./MarketingRedirect').default(store, client),
    require('./Movement').default(store, client),
    require('../features/PhoneVerification/PhoneVerification.route').PhoneVerificationRoute(store, client),
    require('./PlanChange').default(store, client),
    require('../features/Purchase/Purchase.route').PurchaseRoute(store, client),
    require('../features/Pricing/Pricing.route').default(store, client),
    require('../features/Privacy/Privacy.route').PrivacyRoute(store, client),
    require('./Profile').default(store, client),
    require('../features/Reactivation/Reactivation.route').ReactivationRoute(store, client),
    require('../features/Reactivation/Rejoin.route').RejoinRoute(store, client),
    require('../features/Referral/Referral.route').default(store, client),
    require('../features/ResetPassword/ResetPassword.route').ResetPasswordRoute(store, client),
    require('../features/Gifting/Redeem.route').RedeemRoute(store, client),
    require('../features/Refer/Refer.route').ReferRoute(store, client),
    require('../features/Search/Search.route').SearchRoute(store, client),
    require('../features/Settings/Settings.route').SettingsRoute(store, client),
    require('../features/Signup/Signup.route').SignupRoute(store, client),
    require('../features/Terms/Terms.route').TermsRoute(store, client),
    require('../features/TopXList/TopXList.route').TopXListRoute(store, client),
    require('../features/CityGuide/CityGuide.route').CityGuideRoute(store, client),
    require('../features/Try/Try.route').default(store, client),
    require('./Venues').default(store, client),
    require('../features/Videos/Videos.route').VideosRoute(store, client),
    require('../features/FitnessTrends/FitnessTrends.route').FitnessTrendsRoute(store, client),
    require('../features/Welcome/Welcome.route').default(store, client),

    // this is a catch all and needs to stay at the end
    require('./NotFound').default(store, client),
  ],
});
